import React from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const ForecastCategoryNameFilter = ({
  value,
  onChange,
  options,
  classes,
  paddingAvailable = false,
}) => {
  //   const classes = useStyles();

  return (
    <Grid item xs={12} container component={Paper} spacing={2}>
      <Grid
        item
        xs={12}
        sm={12}
        style={paddingAvailable ? {} : { paddingTop: 0 }}
      >
        <FormControl fullWidth className={classes.formControl}>
          <InputLabel
            className={classes.filterLabel}
            style={{ color: !value.includes("All") ? "#4472c4" : "#000" }}
            id="select-region-label"
          >
            Forecast Category:
          </InputLabel>
          <Select
            data-test="Forecast_Category_Name"
            value={value}
            onChange={onChange}
            name="Forecast_Category_Name"
            multiple
          >
            <MenuItem value={"All"}>All</MenuItem>
            {options &&
              options.map((item) => (
                <MenuItem key={item.Forecast_Category_Name} value={item.Forecast_Category_Name}>
                  {item.Forecast_Category_Name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default ForecastCategoryNameFilter;
